import { useNavigate, useParams } from 'react-router-dom';

import { Paper, Skeleton, useTheme } from '@mui/material';

import { useGetSupportFormById } from '@frontend/features/agencies/queries';
import { SupportForm } from '@frontend/features/support-forms/components';
import { DynamicFieldsProvider } from '@frontend/features/support-forms/components/DynamicFieldsContext';
import { routes } from '../routes';

export const ExternalSupportForm = () => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: form, isLoading: formLoading } = useGetSupportFormById({
    id,
  });

  if (formLoading) {
    return (
      <Skeleton
        sx={{
          backgroundColor: theme.palette.field.main,
          maxWidth: theme.spacing(10),
        }}
      />
    );
  }

  if (!form) {
    navigate(routes.error404);
    return;
  }

  const fields = JSON.parse(form.customizableFields);

  return (
    <Paper
      sx={{
        height: '100%',
        minHeight: '100vh',
      }}
    >
      <DynamicFieldsProvider fields={fields}>
        <SupportForm
          title={form.title}
          description={form.description}
          customLogoUrl={form.internalLogoUrl ?? form.customLogoUrl}
          agencyId={`${form.agencyId}`}
          workflowId={form.workflowId}
        />
      </DynamicFieldsProvider>
    </Paper>
  );
};
